import * as Yup from 'yup'
import LookupType from './LookupType'

export const BoulderWorkOrderCementUsed = Yup.object().shape({
    id: Yup.number().nullable(),
    boulder_work_order_id: Yup.number().nullable(),
    color: Yup.string().nullable(),
    bags_used: Yup.number().nullable()
})

export const BoulderWorkOrderCrewMember = Yup.object().shape({
    id: Yup.number().nullable(),
    boulder_work_order_id: Yup.number().nullable(),
    
    employee_id: Yup.number().nullable(),
    manual_entry_name: Yup.string().nullable()
})

export const BoulderWorkOrderSchema = Yup.object().shape({
    id: Yup.number().nullable(),
    job_id: Yup.number().nullable(),
    job_detail_id: Yup.number().nullable(),
    invoice_number: Yup.string().nullable(),
    date: Yup.string().nullable(),
    company: LookupType.nullable(),
    company_supervisor: LookupType.nullable(),
    job_name: Yup.string().nullable(),

    property_owner: LookupType.nullable(),
    address_line_1: Yup.string().nullable(),
    address_line_2: Yup.string().nullable(),
    city: Yup.string().nullable(),
    state: Yup.string().nullable(),
    zip_code: Yup.string().nullable(),
    county: Yup.string().nullable(),
    key_map: Yup.string().nullable(),
    
    crew_members: Yup.array().of(BoulderWorkOrderCrewMember).nullable(),
    other_comments: Yup.string().nullable(),
    problems_needing_attention: Yup.string().nullable(),
    work_done_today: Yup.string().nullable(),
    
    
    cement_used: Yup.array().of(BoulderWorkOrderCementUsed).nullable(),
    pieces_of_half_inch_steel_used: Yup.number().nullable(),
    pieces_of_three_eighths_inch_steel_used: Yup.number().nullable(),
    coloring_used: Yup.string().nullable(),
    waterproofing_used: Yup.string().nullable(),
    yards_of_gunite_shot: Yup.number().nullable(),

    driver_name: Yup.string().nullable(),
    driver_in: Yup.string().nullable(),
    on_job: Yup.string().nullable(),
    break_start: Yup.string().nullable(),
    break_end: Yup.string().nullable(),
    leave_job: Yup.string().nullable(),
    driver_out: Yup.string().nullable(),

    mileage_one_way: Yup.string().nullable(),
})